<template>
  <v-dialog v-model="internalValue" persistent max-width="85%">
    <Card class="sub_battery_dialog pa-2">
      <div class="sticky-header">
        <v-layout row align-center class="ma-2 pt-2">
          <v-flex xs11 class="headline text-xs-center">Main Battery: {{ activeMainBatteryName || activeMainBatteryId || 'N/A'
          }}</v-flex>
          <v-flex xs1 class="headline text-xs-right">
            <v-icon @click="internalValue = false">close</v-icon>
          </v-flex>
        </v-layout>
        <v-divider class="custom-divider" />

        <div class="secondary_battery-container pa-2">
          <div class="secondary_battery pa-2" v-for="(sub, id) in subBatteryList" :key="sub.name">
            <Card class="pa-3" :class="id === activeSubBatteryId ? 'selected-card' : 'sub-battery'"
              @click="activeSubBatteryId = id">
              <div class="text-xs-center">{{ sub && sub.name ? sub.name : 'NO SUB BATTERY SELECTED 1' }}</div>
              <v-layout row wrap>
                <v-flex xs4 pl-2> SoC <span v-show="sub.soc !== null">: {{ sub.soc }}%</span></v-flex>
                <v-flex xs8>
                  <ProgressBar :value="sub.soc" :unique="`soc${id}`" />
                </v-flex>
                <v-flex xs4 pl-2> DoD <span v-show="sub.dod !== null">: {{ sub.dod }}%</span></v-flex>
                <v-flex xs8>
                  <ProgressBar :value="sub.dod" :unique="`dod${id}`" />
                </v-flex>
                <v-flex xs4 pl-2> SoH <span v-show="sub.soh !== null">: {{ sub.soh }}%</span></v-flex>
                <v-flex xs8>
                  <ProgressBar :value="sub.soh" :unique="`soh${id}`" />
                </v-flex>
              </v-layout>
            </Card>
          </div>
        </div>
        <v-divider class="custom-divider pa-2" />
      </div>
      <v-layout row wrap justify-start mx-3 v-if="activeSubBatteryId && subBatteryList[activeSubBatteryId]">
        <v-flex xs12 md7>
          <div class="headline text-xs-left">
            {{ subBatteryList[activeSubBatteryId].name || '' }}
          </div>
        </v-flex>
        <v-flex xs12 md5 pa-2>
          <div class="legend-container" v-if="subBatteryList[activeSubBatteryId].legend">
            <MapLegend v-for="leg in subBatteryList[activeSubBatteryId].legend" :key="leg.name" :text="$t(leg.name)"
              :shape="leg.attr" />
          </div>
        </v-flex>
        <v-flex xs12 pa-2>
          <v-divider class="custom-divider" />
        </v-flex>

        <v-flex xs12 md7 ma-0 pa-0>
          <v-layout row wrap>
            <template v-if="subBatteryList[activeSubBatteryId].details">
              <template v-for="(data, param) in subBatteryList[activeSubBatteryId].details">
                <v-flex v-if="m2mFeMap[param]" xs12 sm6 md4 :key="param">
                  <Card class="ma-2 py-3 px-4">
                    <v-layout row>
                      <v-flex xs8 :style="{ fontSize: '14px' }">{{
                        m2mFeMap[param].name
                      }}</v-flex>
                      <v-flex xs4 :style="{ fontSize: '14px', fontWeight: 600 }">
                        <span class="text-xs-left" :class="data == null ? 'error--text' : 'number--text'">
                          {{ data == null ? 'N/A' : data }} </span>
                        <span v-show="m2mFeMap[param].unit">{{ m2mFeMap[param].unit }}</span>
                      </v-flex>
                    </v-layout>
                  </Card>
                </v-flex>
              </template>
            </template>
          </v-layout>
        </v-flex>

        <v-flex hidden-sm-and-down md1 d-flex justify-center>
          <v-divider class="custom-divider" vertical />
        </v-flex>

        <v-flex xs6 md4>
          <div class="icon-container">
            <v-layout row wrap>
              <v-flex xs6 v-for="(item, index) in imageRepList" :key="index">
                <div class="icon-value-container mb-3">
                  <div>
                    <img class="img-device" :src="item.icon" width="70px" height="70px" />
                  </div>
                  <div class="ml-2">
                    <div>{{ item.label }}</div>
                    <div>
                      <span :class="item.value === null ? 'na-value' : item.isText ? 'text-value' : 'value'">
                        {{ item.displayValue }}
                      </span>
                      <span v-if="item.unit && item.value !== null"> {{ item.unit }} </span>
                    </div>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
    </Card>
  </v-dialog>
</template>

<script>
import ProgressBar from "./ProgressBar.vue";
import MapLegend from "@/components/common/MapLegend";

export default {
  name: "SubBatteryDialog",
  components: {
    ProgressBar,
    MapLegend,
  },
  props: {
    value: Boolean,
    subBatteryList: Object,
    m2mFeMap: Object,
    activeMainBatteryId: String,
    activeMainBatteryName: String,
  },
  data() {
    return {
      activeSubBatteryId: null,
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    activeSubBattery() {
      return this.subBatteryList && this.activeSubBatteryId ? this.subBatteryList[this.activeSubBatteryId] : null;
    },
    imageRepList() {
      if (!this.activeSubBattery || !this.activeSubBattery.imageRep) return [];
      const rep = this.activeSubBattery.imageRep;
      return [
        { label: "SoC", value: rep.soc, displayValue: rep.soc ? rep.soc : 'N/A', unit: "%", icon: require("@/assets/battery/soc.svg") },
        { label: "Max Chrg Curr Allwd", value: rep.max_chrg_cur_alwd, displayValue: rep.max_chrg_cur_alwd ? rep.max_chrg_cur_alwd : 'N/A', unit: "A", icon: require("@/assets/battery/charge.svg") },
        { label: "SoH", value: rep.soh, displayValue: rep.soh ? rep.soh : 'N/A', unit: "%", icon: require("@/assets/battery/soh.svg") },
        { label: "Avg Cell Volt", value: rep.avg_cell_vlt, displayValue: rep.avg_cell_vlt ? rep.avg_cell_vlt : 'N/A', unit: "V", icon: require("@/assets/battery/cellVolt.svg") },
        {
          label: "Fan Status",
          value: rep.fan_status,
          displayValue: rep.fan_status === null ? 'N/A' : (rep.fan_status == 0 ? 'STOPPED' : 'RUNNING'),
          isText: true,
          icon: require("@/assets/battery/fan.svg")
        },
        { label: "Avg Cell Temp", value: rep.avg_cell_temp, displayValue: rep.avg_cell_temp ? rep.avg_cell_temp : 'N/A', unit: "°C", icon: require("@/assets/battery/thermometer.svg") },
      ];
    }
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.activeSubBatteryId = Object.keys(this.subBatteryList)[0];
      }
    },
    subBatteryList(newList) {
      if (this.value && !this.activeSubBatteryId && Object.keys(newList).length > 0) {
        this.activeSubBatteryId = Object.keys(newList)[0];
      }
    }
  }
};
</script>

<style scoped>
.sub_battery_dialog {
  border: 1px solid #334079 !important;
  border-radius: 8px;
  background-color: var(--v-bg-base) !important;
  transform: translateY(-2px);
  box-shadow: 1px 4px 10px rgba(74, 122, 255, 0.7);
}

.secondary_battery-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
}

.secondary_battery {
  width: 20%;
  /* height: 150px; */
}

@media (max-width: 960px) {
  .secondary_battery {
    width: 33.33%;
  }
}

@media (max-width: 600px) {
  .secondary_battery {
    width: 100%;
  }
}

.legend-container {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.icon-container {
  padding: 16px;
}

.icon-value-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.value {
  font-size: 24px;
  font-weight: 700;
  color: #668cf6;
  line-height: 1;
}

.text-value {
  font-size: 24px;
  font-weight: 700;
  color: #0c974b;
}

.na-value {
  font-size: 24px;
  font-weight: 700;
  color: #ff5252;
}

.custom-divider {
  border-color: #334079 !important;
}

.sticky-header {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: inherit;
  background: var(--v-bg-base);
}

.sub-battery {
  cursor: pointer;
 
  transition: all 0.2s ease;
}

.theme--dark .sub-battery {
  background-color: var(--v-primary-lighten2) !important;
}

.theme--light .sub-battery {
  background-color: var(--v-primary-darken1) !important;
}
 

.sub-battery:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.selected-card {
  cursor: pointer;
  border: 2px solid #668cf6 !important;
  box-shadow: 0 0 10px rgba(102, 140, 246, 0.5) !important;
  transform: scale(1.02);
  transition: all 0.3s ease;
}

.theme--dark .img-device {
  filter: brightness(0) saturate(100%) invert(78%) sepia(0%) saturate(26%) hue-rotate(258deg) brightness(98%) contrast(98%);
}

.theme--light .img-device {
  filter: brightness(0) saturate(100%) invert(52%) sepia(16%) saturate(341%) hue-rotate(181deg) brightness(98%) contrast(87%);
}
</style>
